module.exports = __webpack_public_path__ + "img/24-about.a64c9a15.jpg";